<style>
.ball_1 {
  background-color: #aadcd8 !important;
}

.ball_2 {
  background-color: #58b0c2 !important;
}

.ball_3 {
  background-color: #ededee !important;
}

.ball_4 {
  background-color: #e2231a !important;
}

.input-group {
  flex-wrap: unset !important;
}

.search-input {
  min-width: 300px;
}

body {
  overflow: overlay;
}

.aside-collapsed {
  overflow: overlay !important;
}

.wrapper .section-container {
  margin-bottom: 0 !important;
}

.content-heading {
  position: fixed;
  width: 100%;
  z-index: 120;
}

.app-view {
  margin-top: 67px;
}

.sidebar-removed {
  margin-left: 0px !important;
}

style .vs__search::placeholder,
.style .vs__dropdown-toggle,
.style .vs__dropdown-menu {
  border: none;
  padding: 0;
}

.v-select-toggle {
   overflow: hidden;
}

sup {
  top: -0.5em;
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

.my-custom-scrollbar {
  position: relative;
  height: 200px;
  width: 600px;
  overflow: auto;
}

.table-wrapper-scroll-y {
  display: block;
}

td > input.form-control,
td > .input-group > input.form-control,
td > select.custom-select {
  width: auto;
}

@media (min-width: 768px) {
  #angle-item {
    position: fixed;
    height: calc(100vh - 70px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

svg.mx-calendar-icon {
  height: auto !important;
}

.flatdoc-wrapper .flatdoc-content > h1 {
  padding: 9px 0 !important;
}

.gold {
  color: #ffd700;
}

.bg-gold {
  color: #ffd700;
  background: slategray;
}

.fa-stack-1x {
  line-height: inherit;
  font-size: small;
  position: absolute;
  top: -16;
}

.fa-stack-2x {
  font-size: 1em;
}

.table-responsive {
  overflow-y: scroll;
  min-height: 10vh;
  max-height: calc(100vh - 250px);
  display: block;
}

caption {
  caption-side: top;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<template>
  <div>
    <nprogress-container></nprogress-container>
    <loading :active="appLoading" :can-cancel="false"></loading>
    <div class="wrapper" v-if="appLoading == false">
      <!-- top navbar-->
      <header class="topnavbar-wrapper">
        <!-- START Top Navbar-->
        <nav class="navbar topnavbar" role="navigation">
          <!-- START navbar header-->
          <div class="navbar-header">
            <div class="brand-logo">
              <span class="img-fluid navbar-logo-expanded"
                ><img alt="App Logo"
              /></span>
            </div>
            <router-link
              class="navbar-brand"
              :to="{ name: 'dashboard' }"
              v-allowed:view="['STAFF', 'CLIENT', 'RESELLER']"
            >
              <div class="brand-logo-collapsed">
                <span
                  class="img-fluid navbar-logo-collapsed"
                  style="max-width: 30px"
                  ><img alt="App Logo"
                /></span>
              </div>
            </router-link>
          </div>
          <!-- END navbar header-->
          <!-- START Left navbar-->
          <ul
            class="navbar-nav mr-auto flex-row"
            v-allowed:view="['STAFF', 'RESELLER']"
          >
            <li class="nav-item">
              <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
              <a
                class="nav-link d-none d-md-block d-lg-block d-xl-block"
                data-trigger-resize=""
                data-toggle-state="aside-collapsed"
                style="cursor: pointer"
              >
                <em><i class="fa-solid fa-bars"></i></em>
              </a>
              <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
              <a
                class="nav-link sidebar-toggle d-md-none"
                data-toggle-state="aside-toggled"
                data-no-persist="true"
                style="cursor: pointer"
              >
                <em><i class="fa-solid fa-bars"></i></em>
              </a>
            </li>
            <li class="nav-item" v-allowed:view="['STAFF']">
              <a class="nav-link" data-search-open style="cursor: pointer">
                <em><i class="fa-solid fa-magnifying-glass"></i></em>
              </a>
            </li>
          </ul>
          <!-- END Left navbar-->
          <!-- START Right Navbar-->
          <ul class="navbar-nav flex-row align-items-center">
            <li class="nav-item" v-allowed:view="['STAFF']">
                 <router-link :to="{ name: 'notifications' }" class="nav-link notification-alerts" v-tooltip="'Check notifications'">
                 <i class="fa fa-bell"></i>
                 <span class="notify-count" v-if="notificationAlerts.length > 0"></span>
              </router-link>
            </li>
            <li class="nav-item dropdown mr-4">
              <a
                class="dropdown-toggle"
                href="#"
                style="color: #FFFFFF; font-size: 15px"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                Signed in as
                <strong
                  >{{ userDetails.firstNames }}
                  {{ userDetails.lastName }}</strong
                >
              </a>
              <div class="dropdown-menu mr-4" aria-labelledby="navbarDropdown">
                <!--<div class="dropdown-divider" v-allowed:view="['STAFF']"></div> 
                UNCOMMENT WHEN WE ADD MORE OPTIONS TO DROPDOWN-->
                  <button
                    class="btn btn-link dropdown-item"
                    style="color: #656565; font-size: 15px"
                    type="button"
                    @click="backendLogout()"
                  >
                    Logout
                  </button>
              </div>
            </li>
          </ul>
          <!-- END Right Navbar-->
          <!-- START Search form-->
          <form class="navbar-form" role="search" @submit.prevent="doSearch()">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                v-model="searchTerm"
                placeholder="Type and hit enter ..."
              />
              <div
                class="fa fa-times navbar-form-close"
                data-search-dismiss=""
              ></div>
            </div>
            <button class="d-none" type="submit">Submit</button>
          </form>
          <!-- END Search form-->
        </nav>
        <!-- END Top Navbar-->
      </header>
      <!-- sidebar-->
      <aside class="aside-container" v-allowed:view="['STAFF', 'RESELLER']">
        <!-- START Sidebar (left)-->
        <div class="aside-inner">
          <nav class="sidebar pt-1" data-sidebar-anyclick-close="">
            <!-- START sidebar nav-->
            <ul class="sidebar-nav">
              <!-- START user info-->
              <li class="has-user-block">
                <div class="collapse" id="user-block">
                  <div class="item user-block">
                    <!-- Name and Job-->
                    <div class="user-block-info">
                      <span class="user-block-name"
                        >Hello, {{ loggedInUser.firstNames }}</span
                      >
                    </div>
                  </div>
                </div>
              </li>
              <!-- END user info-->
              <!-- Iterates over all sidebar items-->
              <li v-allowed:view="['STAFF']" title="Search">
                <a data-search-open>
                  <em><i class="fa-solid fa-magnifying-glass"></i></em>
                  <span class="">Search</span>
                </a>
              </li>
              <li class="nav-heading">
                <span>{{ navbarStructure.heading }}</span>
              </li>
              <li>
                <router-link
                  v-if="navbarStructure.backRoute"
                  :to="{
                    name: navbarStructure.backRoute.routeName,
                    params: navbarStructure.backRoute.routeParams,
                    query: navbarStructure.backRoute.routeQuery,
                  }"
                >
                  <em><i :class="navbarStructure.backRoute.iconClass"></i></em>
                  <span>{{ navbarStructure.backRoute.title }}</span>
                </router-link>
              </li>
              <li
                :title="menuItem.title"
                v-for="(menuItem, index) in navbarStructure.menu"
                :key="index"
              >
                <!-- IF CHILDREN -->
                <a
                  :href="'#' + menuItem.title"
                  :title="menuItem.title"
                  data-toggle="collapse"
                  aria-expanded="false"
                  v-if="menuItem.children.length > 0"
                >
                  <em><i :class="menuItem.iconClass"></i></em>
                  <span data-localize="sidebar.nav.extra.EXTRA">{{
                    formatSpaces(menuItem.title)
                  }}</span>
                </a>
                <ul
                  class="sidebar-nav sidebar-subnav collapse"
                  :id="menuItem.title"
                  v-if="menuItem.children.length > 0"
                >
                  <li
                    v-for="(subMenuItem, index) in menuItem.children"
                    :key="index"
                  >
                    <!-- IF CHILDREN -->
                    <template v-if="subMenuItem.children">
                      <a
                        :href="'#' + subMenuItem.title"
                        :title="subMenuItem.title"
                        data-toggle="collapse"
                        aria-expanded="false"
                        v-if="subMenuItem.children.length > 0"
                      >
                        <em><i :class="subMenuItem.iconClass"></i></em>
                        <span data-localize="sidebar.nav.extra.EXTRA">{{
                          formatSpaces(subMenuItem.title)
                        }}</span>
                      </a>
                      <ul
                        class="sidebar-nav sidebar-subnav collapse"
                        :id="subMenuItem.title"
                        v-if="subMenuItem.children.length > 0"
                      >
                        <li
                          v-for="(subSubMenuItem, index) in subMenuItem.children"
                          :key="index"
                        >
                          <router-link
                            style="white-space: pre-wrap !important"
                            class="sidebar-subchild"
                            :to="{
                              name: subSubMenuItem.routeName,
                              params: subMenuItem.routeParams,
                              query: subMenuItem.routeQuery,
                            }"
                          >
                            <em><i :class="subSubMenuItem.iconClass"></i></em>
                            <span>{{ subSubMenuItem.title }}</span>
                          </router-link>
                        </li>
                      </ul>
                    </template>


                    <!-- NO CHILDREN -->
                    <router-link
                      style="white-space: pre-wrap !important"
                      :to="{
                        name: subMenuItem.routeName,
                        params: menuItem.routeParams,
                        query: menuItem.routeQuery,
                      }"
                      v-else
                    >
                      <em><i :class="subMenuItem.iconClass"></i></em>
                      <span>{{ subMenuItem.title }}</span>
                    </router-link>
                  </li>
                </ul>

                <!-- IF NO CHILDREN -->
                <router-link
                  :to="{
                    name: menuItem.routeName,
                    params: menuItem.routeParams,
                  }"
                  v-if="menuItem.children.length == 0"
                >
                  <em><i :class="menuItem.iconClass"></i></em>
                  <span>{{ menuItem.title }}</span>
                </router-link>
              </li>
              <div class="row">
                <div class="col-md-12">
                  <hr />
                </div>
              </div>
              <li title="Changelog">
                <a @click="viewChangelog()">
                  <span class="text-muted">Changelog</span>
                  <sup
                    ><span
                      v-if="versionUpdated"
                      style="font-size: 8px"
                      class="d-inline badge badge badge-warning"
                      >1</span
                    ></sup
                  >
                </a>
              </li>
            </ul>
            <!-- END sidebar nav-->
          </nav>
        </div>
        <!-- END Sidebar (left)-->
      </aside>
      <!-- offsidebar-->
      <aside class="offsidebar d-none">
        <!-- START Off Sidebar (right)-->
        <nav>
          <ul></ul>
        </nav>
        <!-- END Off Sidebar (right)-->
      </aside>
      <!-- Main section-->
      <section
        class="section-container"
        :class="{ 'sidebar-removed': sidebarRemoved }"
      >
        <!-- Page content-->
        <div
          v-if="this.$route.path.includes('/client')"
          class="content-wrapper"
          id="service-panel-main"
        >
          <div class="flatdoc-wrapper">
            <div class="flatdoc">
              <div class="flatdoc-menu" id="client-menu">
                <ul>
                  <li id="root-item" class="level-0">
                    <ul class="level-1" id="root-list">
                      <li id="angle-item" class="level-1">
                        <a class="level-1 m-0">Client Menu</a>
                        <ul class="level-3" id="angle-list">
                          <li
                            class="level-3 cmItem"
                            v-for="(
                              menuItem, index
                            ) in clientNavbarStructure.menu"
                            :key="index"
                          >
                            <!-- IF CHILDREN -->
                            <div 
                              class="dropdown mr-5 icmItem" 
                              v-if="menuItem.children.length > 0"
                            >
                              <a 
                                class="nav-link dropdown-toggle caret-off mr-5" 
                                data-toggle="dropdown" 
                                href="#" 
                                role="button" 
                                aria-haspopup="true" 
                              >
                                <em><i :class="menuItem.iconClass"></i></em>
                                <span class="client-dropdown-items-text">{{ menuItem.title }}</span>
                              </a>
                              <div 
                                class="dropdown-menu"
                                v-if="menuItem.children.length > 0"
                              >
                                <li
                                  v-for="(subMenuItem, index) in menuItem.children"
                                  :key="index"
                                >
                                  <div v-if="userContainsPermission(subMenuItem.groupPermissions)">
                                    <div class="client-divider" :class="{'dropdown-divider': subMenuItem.divider}"></div>
                                    <div class="client-dropdown-item">
                                      <router-link
                                        class="dropdown-item client-dropdown-items"
                                        :to="{
                                          name: subMenuItem.routeName,
                                          params: menuItem.routeParams,
                                          query: menuItem.routeQuery,
                                        }"
                                      >
                                        <em class="client-dropdown-items-icon"><i :class="subMenuItem.iconClass"></i></em>
                                        <span class="client-dropdown-items-text">{{ subMenuItem.title }}</span>
                                      </router-link>
                                    </div>
                                  </div>
                                </li>
                              </div>
                            </div>

                            <!-- NO CHILDREN -->
                            <div v-if="userContainsPermission(menuItem.groupPermissions)">
                               <router-link
                                 :to="{
                                   name: menuItem.routeName,
                                   params: clientNumber,
                                 }"
                                 v-if="menuItem.children.length == 0"
                               >
                                 <em><i :class="menuItem.iconClass"></i></em>
                                 <span class="">
                                   {{ menuItem.title }}
                                 </span>
                                 <div
                                   v-if="menuItem.badge"
                                   class="float-right"
                                   :class="menuItem.badge.class"
                                 >
                                   {{ menuItem.badge.text }}
                                 </div>
                               </router-link>
                             </div>
                          </li>
                          <div class="row">
                            <div class="col-md-12">
                              <hr />
                            </div>
                          </div>
                          <li title="Feedback" class="clientLog" v-allowed:view="['CLIENT']">
                            <a @click="showFeedback('Feedback', 'What feedback would you like to give us?')">
                              <i class="fa-solid fa-comment-dots"></i>
                              <span class="clientFeedbackText">Feedback</span>
                            </a>
                          </li> 
                          <li title="Changelog" class="clientLog">
                            <a @click="viewClientChangelog()">
                              <span class="clientLogText">Changelog</span>
                              <sup
                                ><span
                                  v-if="versionUpdated"
                                  style="font-size: 8px"
                                  class="d-inline badge badge badge-warning"
                                  >1</span
                                ></sup
                              >
                            </a>
                          </li> 
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div class="flatdoc-content">
                <div class="page-header-section col-md-12 py-2" v-allowed:view="['STAFF', 'CLIENT', 'RESELLER']" v-if="showPageTitle || serverLoading == true">
                  <div class="page-header-section-wrapper row" v-if="showPageTitle">
                    <div class="client-menu-toggle-wrapper col-md-10 pl-0 d-flex align-items-center">
                      <div class="menu-toggle-wrapper">
                        <button class="btn btn-secondary" type="button" @click="toggleClientMenu">
                          <em class="fa fa-exchange d-none d-md-block"></em>
                        </button>
                      </div>
                      <div class="page-title-wrapper ml-2">
                        <span class="h3" v-allowed:view="['STAFF']" id="appPageTitle">{{ pageTitle }}</span>
                        <span class="client-title" v-allowed:view="['CLIENT']" id="appPageTitle">{{ clientPageTitle }}</span>
                      </div>
                    </div>
                    <div class="col-md-2" v-if="haloUrl">
                      <button type="button" class="btn btn-primary halo-btn" v-allowed:view="['STAFF']" @click="goToHalo()">
                        <em></em> Halo
                      </button>
                    </div>
                  </div>
                </div>
                <h2 id="angle-section-a" class="h6 pt-1">
                  <router-view></router-view>
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="content-wrapper" id="service-panel-main">
          <div
            class="content-heading"
            v-allowed:view="['STAFF', 'CLIENT', 'RESELLER']"
            v-if="showPageTitle || serverLoading == true"
          >
            <div>
              <div v-if="showPageTitle">
                {{ pageTitle }}
              </div>
            </div>
          </div>
          <!-- MAIN CONTENT -->
          <div class="app-view">
            <router-view></router-view>
          </div>
        </div>
      </section>
    </div>
    <modal
      title="What's changed?"
      ref="changelogModal"
      size="modal-lg"
      dismiss-text="Close"
      :save-needed="false"
    >
      <div v-if="changelog">
        <div
          v-for="(log, index) in changelog"
          :key="index"
          @click="toggleLog(log)"
          style="cursor: pointer"
        >
          <h5>
            <strong>{{ log.version }} - {{ log.date }}</strong>
          </h5>
          <div v-if="index == 0 || log.show">
            <span class="badge bg-green"
              ><i class="fa fa-check"></i> Features</span
            >
            <ul v-for="(feature, index) in log.features" :key="index">
              <li v-if="feature">
                <span class="font-weight-bold">{{ feature.title }}</span> -
                <span class="font-weight-light">{{ feature.description }}</span>
              </li>
            </ul>
          </div>
          <div v-if="index == 0 || log.show">
            <span class="badge bg-warning"
              ><i class="fa fa-bug"></i> Bugs Squashed</span
            >
            <ul v-for="(bug, index) in log.bugs" :key="index">
              <li>
                <span class="font-weight-bold">{{ bug.title }}</span> -
                <span class="font-weight-light">{{ bug.description }}</span>
              </li>
            </ul>
          </div>
          <div v-if="index == 0 || log.show">
            <span class="badge bg-danger"
              ><i class="fa fa-laptop"></i> Dev Stuff</span
            >
            <ul v-for="(dev, index) in log.dev" :key="index">
              <li>
                <span class="font-weight-bold">{{ dev.title }}</span> -
                <span class="font-weight-light">{{ dev.description }}</span>
              </li>
            </ul>
          </div>
          <hr />
        </div>
      </div>
      <div v-else>No new updates have been made yet...</div>
    </modal>

    <ClientChangelogModal ref="clientChangelogModal"/>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import Modal from "@/components/GeneralComponents/Modal";
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import ClientChangelogModal from "@/components/Admin/Modals/ClientChangelogModal"

const homeNavbarStructure = require("@/structures/homeNavbarStructure.json");

var token;

export default {
  components: {
    Modal,
    Loading,
    NprogressContainer,
    ClientChangelogModal
  },
  computed: {
    authHeaders() {
      if (!token) {
        token = this.$localStorage.get("aims-token");
      }
      return {
        Authorization: "Bearer " + token,
      };
    },
  },
  data() {
    return {
      sidebarRemoved: false,
      pageTitle: "",
      clientPageTitle: "",
      navbarStructure: {},
      userDetails: {},
      clientNavbarStructure: {},
      loggedInUser: {},
      searchResults: [],
      serverLoading: false,
      showPageTitle: true,
      titleBadges: [],
      activeThemeName: "darcula",
      changelog: [],
      clientChangelog: [],
      searchTerm: "",
      clientNumber: null,
      notificationAlerts: [],
      haloUrl: null,
      options: [
        {
          name: "Profile",
          routeName: "clientdetail",
        },
        {
          name: "Statement",
          routeName: "clientstatement",
        },
        {
          name: "Correspondence",
          routeName: "clientcorrespondence",
        },
      ],
    };
  },
  created() {
    this.initAuth();
    this.versionCheck();

    this.$root.$on(
      "START_PROGRESS",
      function () {
        this.serverLoading = true;
      }.bind(this)
    );

    this.$root.$on(
      "STOP_PROGRESS",
      function () {
        this.serverLoading = false;
      }.bind(this)
    );

    this.$root.$on(
      "SET_PAGE_TITLE",
      function (pageTitle) {
        this.pageTitle = pageTitle;
        document.title = this.pageTitle;
      }.bind(this)
    );
    this.$root.$on(
      "SET_CLIENT_PAGE_TITLE",
      function (clientPageTitle) {       
        this.clientPageTitle = clientPageTitle;  
        document.title = clientPageTitle;      
      }.bind(this)
    );
    this.$root.$on(
      "HIDE_PAGE_TITLE",
      function () {
        this.showPageTitle = false;
      }.bind(this)
    );
    this.$root.$on(
      "SET_PAGE_TITLE_BADGES",
      function (titleBadges) {
        this.titleBadges = titleBadges;
      }.bind(this)
    );
    this.$root.$on(
      "SET_HOME_NAVBAR",
      function () {
        this.clientNumber = null;
        this.clientNavbarStructure = {};
        this.navbarStructure = this.getRestrictedNavStructure(homeNavbarStructure);
      }.bind(this)
    );
    this.$root.$on(
      "SET_CLIENT_NAVBAR",
      function (clientNavbarStructure, clientNumber) {
        this.clientNumber = clientNumber;
        this.clientNavbarStructure = clientNavbarStructure;     
        
        this.getHalo();

        if (this.userContainsPermission(['CLIENT'])) {
          /* this.setSegments(); */
        }
      }.bind(this)
    );
  },
  mounted() {
    this.$http.get(this.$config.aimsAPI + "users/user/loggedInUser").then(
      (response) => {
        this.userDetails = response.data;
      },
      (error) => {
        console.error(error);
        this.showError("Error Fetching User", error);
      }
    );

    var interval = 0;
    
    this.$http.get(this.$config.aimsAPI + "users/groups").then(
      (response) => {
        this.$root.userGroups = response.data;

        this.$root.$emit("SET_HOME_NAVBAR");

        this.appLoading = false;

        let templateScript = document.createElement("script");
        templateScript.setAttribute("src", "/template/js/app.js");
        document.head.appendChild(templateScript);

        if (!this.userContainsPermission(["STAFF", "RESELLER"])) {
          this.sidebarRemoved = true;
        }

        if (this.$root.userGroups.length == 0) {
          interval = 100;
        }

        const waitForPermissions = setInterval(() => {
          if (this.$root.userGroups.length >= 0) {
            if (this.userHasRouteAccess(this.$route.name) == false) {
              this.$swal({
                type: "warning",
                title: "Access Denied",
                text:
                  "You do not have access to view '" + this.$route.meta.title + "'",
              }).then(() => {
                this.$router.replace({
                  name: "login",
                });
              });
            }
            -clearInterval(waitForPermissions);
          }
        }, interval);

      },
      (error) => {
        console.warn(error);
        this.logout("tokenIssue=1");
      }
    );

    this.loadTheme();

    this.$http.get(this.$config.aimsAPI + "changelog").then(
      (response) => {
        this.changelog = response.data;
      },
      (error) => {
        this.showError("Error fetching changelog", error);
        console.error(error);
      }
    );

    this.$http.get(this.$config.aimsAPI + "changelog/client").then(
      (response) => {
        this.clientChangelog = response.data;
      },
      (error) => {
        this.showError("Error Fetching Client changelog", error);
        console.error(error);
      }
    );

    this.$http.get(this.$config.aimsAPI + "alerts").then(
      (response) => {
        this.notificationAlerts = response.data;
      },
      (error) => {
        this.showError("Error fetching alerts", error);
        console.error(error);
      }
    );
  },
  methods: {
    loadTheme() {
      if (this.activeThemeName && this.activeThemeName != "") {
        var link = document.createElement("link");
        link.href =
          "/servicepanel-themes/adept.servicepanel.co.za/" +
          this.activeThemeName +
          "-theme.css";
        link.type = "text/css";
        link.rel = "stylesheet";
        link.id = "activeTheme";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    },
    getHalo() {
      this.$http.get(this.$config.aimsAPIv3 + "navigation/client/" + this.clientNumber + "/halo").then(
        (response) => {
          this.haloUrl = response.data;
        },(error) => {
          console.error(error);
        }
      );
    },
    formatSpaces(text) {
      var formattedText = text.replace("_", " ");

      return formattedText;
    },
    viewChangelog() {
      this.$refs.changelogModal.open();
    },
    viewClientChangelog() {
      this.$refs.clientChangelogModal.open();
    },
    toggleLog(log) {
      this.$set(log, "show", !log.show);
    },
    toggleClientMenu() {
      $("#client-menu").fadeToggle();
    },
    toggleSaleMenu() {
      document.getElementById("saleNav").click();
    },
    toggleDropdown() {
      $(".dropdown-menu").toggle();
    },
    doSearch() {
      this.$router.push({
        name: "search",
        query: {
          searchTerm: this.searchTerm,
        },
      });
    },
    goToHalo() {
      window.open(this.haloUrl);
    }
  },
  watch: {
    $route(to, from) {
      this.showPageTitle = true;
      if (this.userContainsPermission(["STAFF", "RESELLER"])) {
        if (!to.path.includes("/client")) {
          $("body").removeClass("aside-collapsed");
          this.$root.$emit("SET_HOME_NAVBAR");
        }
      }
    },
  },
};
</script>

<style scoped>
.router-link-active {
  border-left: #e2231a 2px solid !important;
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.h3 {
  line-height: 1.5 !important;
}

.client-title {
  line-height: 1.5 !important;
  font-size: 1.8rem;
  font-weight: 400;
}

.notification-alerts {
  position: relative;
}

.notification-alerts .fa-bell {
  font-size: 1.3em;
}

.notify-count {
  position: absolute;
  top: 28%;
  right: 28%;
  background: #ff902b;
  border-radius: 100%;
  width: 20%;
  height: 20%;
}

.caret-off::before {
  display: none;
}
.caret-off::after {
  display: none;
}

.flatdoc-menu{
  width: 13em;
}

.cmItem {
  width: 13em
}
.icmItem {
  width: 16.5em
}

.client-dropdown-item:hover em,
.client-dropdown-item:hover span
{
  color: #e2231a;
}

.clientLog {
  cursor: pointer;
}

.clientLogText {
  padding-left: 1em;
  color: #858585;
}

.clientFeedbackText {
  padding-left: 3px;
}

.client-dropdown-items-icon {
 margin-right: 3px;
}

.client-dropdown-items-text {
  padding-left: 3px;
}

.sidebar-subchild {
  margin-left: 1em;
}

.halo-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  float: right;
  font-size: 16px;
  font-weight: bolder;
  line-height: 1.5;
  height: 35px;
}

.halo-btn em {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArsAAAK7CAYAAADyY0eCAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4wodDhAxpUVrDgAAAAd0RVh0QXV0aG9yAKmuzEgAAAAMdEVYdERlc2NyaXB0aW9uABMJISMAAAAKdEVYdENvcHlyaWdodACsD8w6AAAADnRFWHRDcmVhdGlvbiB0aW1lADX3DwkAAAAJdEVYdFNvZnR3YXJlAF1w/zoAAAALdEVYdERpc2NsYWltZXIAt8C0jwAAAAh0RVh0V2FybmluZwDAG+aHAAAAB3RFWHRTb3VyY2UA9f+D6wAAAAh0RVh0Q29tbWVudAD2zJa/AAAABnRFWHRUaXRsZQCo7tInAAAcw0lEQVR4nO3dyXrdOLKoUTq/ev9XVg2cTqvZDRuAiGat4R3c49ImA79CkPLXx8fHBsC2bdtWaSD+Wv0PAIjgf6v/AQATVYrXo47+bxfHQEliF8isc8yO9u5rKYaBlMQuEJmYjUMMAymJXSAKYZvbo89PAAPLiV3gbqK2j2eftQgGbiN2gVlELc+IYOA2YhcYRdxy1fdnSPwCl4ld4Cxxy2zuAQOXiV1gD2FLFLa/wCFiF3hE3JKF+AVeErvAtolb6hC/wBdiF/oSuHTw+TkXvtCQ2IU+xC3d2fpCQ2IXahO48JytLzQgdqEegQvHCV8oSuxCDQIXxhG+UIjYhbwELswnfCE5sQu5CFxYR/hCQmIX4hO4EI/whSTELsQkcCEP4QuBiV2IQ+BCfsIXghG7sJ7IhZr+vNuiFxYSu7CGwIU+bHthIbEL9xK50JttL9xM7MJ8Ahf4zrYXbiJ2YR6RC+xh2wsTiV0YS+ACZ9n2wgRiF8YQucBItr0wiNiFa0QuMJPohYvELpwjcoE7iV44SezCfgIXWM29XjhI7MJ7IheIyLYXdhC78JzIBTIQvfCC2IWfRC6QkeiFB8Qu/CVygQpEL3widkHkAjWJXtjELr2JXKAD0UtrYpeORC7QkeilJbFLJyIXQPTSjNilA5EL8JPopQWxS2UiF+A90UtpYpeKRC7AcaKXkv5Z/Q+AwYQuwDUfm1lKIWKXKgxngLHMVEpwjYHsDGOAeVxtID2xS1YiF+A+ope0xC7ZiFyAdUQv6bizSyZCFyAG85g0bHbJwFAFiMeWlxTELpGJXID4RC+hucZAVEIXIBdzm5BsdonGsATIy5aXcGx2iUToAtRgnhOGzS4RGIoA9djyEoLNLqsJXYDazHmWstllFcMPoA9bXpYRu9xN5AL0JXq5nWsM3EnoArBtzgNuZLPLHQw1AL6z5eUWNrvMJnQBeMU5wVRil5kMMAD2cF4wjWsMzGBoAXCUaw1MYbPLaEIXgCucIwxls8sohhMAo9jyMozNLiMIXQBmcL5wmdjlKoMIgJmcM1ziGgNnGT4A3MW1Bk6z2eUMoQvACs4fDhO7HGXQALDSx+Ys4gCxy16GCwCROJPYReyyh4ECQETOJ94Su7xjkAAQmZ888pLY5RnDA4BMnFk8JHZ5xMAAICPnFz+IXb4zKADIzDnGF2KXzwwIACpwFY//iF22zVAAoCZnG2IXgwCA0pxzzYnd3gwAADrwE8zGxG5fXnoAunH2NSR2+/HdLQCdOQObEbu9eMEBwHnYitjtw4sNAH85F5sQuz14oQHgJ+djA2K3Pi8yADznnCxO7NbmBQaA95yXhYndury4ALCfc7MosVuTFxYAjvPnOQsSu7V4SQHgOmdpIWK3Di8mAIzjXC1C7NbghQSA8ZyvBYjd/LyIADCPczY5sZubFxAA5nPeJiZ28/LiAcB9nLtJid2cvHAAcD/nb0JiNx8vGgCs4xxORuzm4gUDgPWcx4mI3Ty8WAAQh3M5CbGbgxcKAOJxPicgduPzIgFAXM7p4MRubF4gAIjPeR2Y2I3LiwMAeTi3gxK7MXlhACAf53dAYjceLwoA5OUcD0bsxuIFAYD8nOeBiN04vBgAUIdzPQixG4MXAgDqcb4HIHbX8yIAQF3O+cXE7lpeAACoz3m/kNhdx4MPAH049xcRu2t44AGgH+f/AmL3fh50AOhLB9xM7N7LAw4A6IEbid37eLABgD90wU3E7j080ADAd/rgBmIXAICyxO58vmsDAJ7RCZOJ3bk8wADAO3phIrE7jwcXANhLN0widufwwAIAR+mHCcTueB5UAOAsHTGY2B3LAwoAXKUnBhK743gwAYBRdMUgYncMDyQAMJq+GEDsAgBQlti9znddAMAsOuMisXuNBxAAmE1vXCB2z/PgAQB30R0nid1zPHAAwN30xwli9zgPGgCwig45SOwCAFCW2D3Gd1MAwGp65ACxu58HCwCIQpfsJHb38UABANHokx3ELgBAXoL3DbH7nocIACApsfua0AUAotMrL4jd5zw4AEAWuuUJsfuYBwYAyEa/PCB2AQDqELzfiN2fPCQAAEWI3a+ELgCQnZ75ROwCANQjeP8ldv/yUAAAFCN2fxO6AEA1+mYTu9vmQQAA6mrfOWIXAKC21sHbPXZbf/gAANV1jl2hCwB00bZ7OscuAEAnLYO3a+y2/LABALrpGLtCFwDoql0HdYvddh8wAMA3rXqoW+wCANBIp9ht9V0MAMALbbqoS+y2+UABAHZq0UddYhcAgIY6xG6L71oAAE4o30kdYhcAgOdKB2/12C394QEA8Frl2BW6AAD7lO2myrELAMB+JYO3auyW/LAAADimYuwKXQCAc8p11P9W/wMACvk18P+vcgcOwArVYtfhAIw2MmBn/d81+4CRPrZ1s2+4SrFr2ANnZR/q7/795iNwVJngrRS7AO+UGNwnPPvfLYKB8qrEroENfNY1ao969HUyT4E/Smx3q8Qu0Fv6YRzI96+l+AVSqxC7BjH0I27vI36ht/Tb3eyxa+hCH6mHbSGfPwczGHpIHbzZYxeoK+1gbcTWFwgvc+waqlCTyM3L1hfqSrvdzRy7QB0pBygv/flMRS+wVNbYNTwhP4Hbg20v1JFyu5s1doGc0g1JhhK+wO3+Wf0POMGAhHx+bUKXrzwTkFO6DrPZBWYRMuxh2wv5pLrOkC12DUKIL80AJBy/1AYMlyl2DT+ITeQyim0vxJdmu5spdoF4Ugw6UrPtBS7J8gtqhhzE4peLuJtnDuJJ0Wc2u8ARYoPVbHqBQzJsdg00WM9WjWg8kxBD+E7LELvAWoKCyEQv8FL02A3/3QIUJiLIxPMK64TuteixC9xPNJCZZxf4InLshv4uAQoSuVThWYb7he22yLEL3EMYUJVnG+4VMnij/umxkF8sKEYE0IU/VwaN2exCT0KXjjz3MF+4byojbnbDfZGgEIc93dnyQjM2u9CH0IW/vA8wT6hvJqNtdkN9caAIhzo8ZssLDdjsQl1+Ex328a7AeGG+iYwUu2G+KFCAgxuO895AQZFiFxjDgQ3neX9gnBCLzCh3dkN8MSA5hzSM4S4vFGKzCzUIXRjPewUFRIhd3znDNQ5kmMf7Bdcs77wo1xiA4xzCcA/XGiCx1ZtdgwPOEbpwP+8dnLO091bHLnCcAxfW8f5BMmIX8vCH7yEG7yIct2y7uzJ2XWGA/RysEI/3EhKw2YX4HKgQl/cT9luy6FwVu7a6sI+DFOLznkJgNrsQlwMU8nCPF/a5feG5InZtdeE1hybk5d2FYGx2IRYHJeTnPYZA7o5dW114zgEJdXif4blbe9BmF2JwMEI93msIQOzCeg5EqMv7DY/dtt29M3ZdYYCfHIRQn/ccFrLZhXUcgNCH9x1+umURelfs2urCVw4+6Md7DwvY7ML9HHjQl/cfbiZ24V4OOsAcgL+m//T/jth1hQF+c8ABf5gHcBObXbiHgw34zlyA36YuRmfHrq0uONCA58wHmMxmF+ZykAHvmBMwkdiFeRxgwF7mBd1Nuw0wM3ZdYaAzBxdwlLkBE9jswngOLOAs84POpixKZ8WurS5dOaiAq8wRGMhmFwCAssQujGMbA4xintDV8NsBM2LXFQY6cjABo5krMIDNLlznQAJmMV/gIrEL1ziIgNnMGboZektgdOy6wkAnDiDgLuYNnGSzCwBAWWIXzrFlAe5m7tDJsNsCI2PXFQa6cOAAq5g/cJDNLhzjoAFWM4fgALEL+zlggCjMIzoYcmtgVOy6wgAAQDg2u7CPLQoQjbkEO4hdeM+BAkRlPlHd5dsDI2LXFQYAAEKy2YXXbE2A6MwpeEHswnMOECAL84rKLt0iuBq7rjAAABCWzS48ZksCZGNuwQNiF35yYABZmV9Udfo2wZXYdYUBAIDQbHbhK1sRIDtzDD4Ru/CXAwKowjyDf52NXVcYAAC406n+tNmF32xBgGrMNdjELmybAwGoy3yjPbELAEBZZ2LXfV0qsfUAqjPnqORwh9rsAgBQltilM9sOoAvzjraOxq4rDAAArHSoR2126cqWA+jG3KMlsUtHBj7QlflHO2IXAICyjsSu+7pUYKsBdGcOUsHuLrXZBQCgLLFLJ7YZAL+Zh7QhdgEAKGtv7LqvS3a2GABfmYtkt6tPbXYBAChL7NKB7QXAY+Yj5YldAADKErtUZ2sB8Jo5SWl7YtcvpwEAENHbTrXZBQBsdylL7FKZ4Q0AzYldAADKehe77uuSla0uwDHmJlm97FWbXQAAyhK7VGQ7AXCO+Uk5YhcAgLJexa77ugDQj+0uGT3tVptdqjGkAYD/iF0AAMoSu1RiqwswhnlKGWIXAICyxC5V2EIAjGWuUsKz2PWXGAAAyORhv9rsAgBQltilAj9qA5jDfCU9sQsAQFliFwCAssQu2fkRG8Bc5iypPYpdf4kBAICMfnSszS4AAGWJXTLzozWAe5i3pCV2AQAoS+wCAFDW99j1y2kAAGT2pWdtdsnK/TGAe5m7pCR2AQAoS+wCAFCW2CUjP0oDWMP8JR2xCwBAWWIXAICyxC4AAGV9jl1/Y5cM3BcDWMscJoP/utZmFwCAssQuAABliV0AAMoSuwAAlCV2ycQvRQDEYB6ThtgFAKAssQsAQFl/Ytff2AUAoJKPbbPZBQDOcW+XFMQuWRiqAMBhYhcAgLLELgAAZYldAADKErsAwFl+n4LwxC4AAGWJXTKwOQAAThG7AACUJXYBAChL7AIAUNXHP9u//91gAACoxmYXALjCLxETmtgFAKAssUt0NgYAwGliFwCAssQuAABliV0AAMoSuwAAlCV2AQAoS+wCAFCW2AUAoCyxCwBAWWIXAICyxC4AAGWJXSLznwoGyMG8JiyxCwBAWWIXAICyxC4AAGWJXQAAyhK7AACUJXYBAChL7AIAUJbYBQCgLLELAEBZYhcAgLLELgAAZYldAADKErsAAJQldgEAKEvsAgBQltgFAKAssQsAQFliFwCAssQukX2s/gcAsIt5TVhiFwCAssQuAABliV0AAMoSuwAAlCV2AQAoS+wCAFCW2AUAoCyxCwBAWWIXAICyxC4AAGWJXaLzn6AEAE4TuwAAlCV2AYAr/ASO0MQuAABliV0AAMoSuwAAlCV2AQAo659t236t/kcAAMAMNrtk4Dd9AYAzfoldAOAsywjCE7sAAJQldgEAKEvsAgBQltgFAKAssUsWfgkCIBZzmRTELgAAZYldAADKErsAAJQldgEAKOtP7P5a+q+AffwyBEAM5jEZ/No2m10AAAoTuwAAlCV2AQAoS+ySjXtiAGuZw6QidgEAKEvsAgBQltgFAKCsz7Hrb+2ShftiAGuYv2TxX9fa7AIAUJbYBQCgLLFLVn6UBnAvc5eUxC4AAGWJXQAAyhK7AACUJXbJzP0xgHuYt6T1PXb9rV0AADL70rM2uwAAlCV2yc6P1gDmMmdJTewCAFCW2AUAoKxHseuX1MjGj9gA5jBfyeZHx9rsAgBQltgFAKAssUsVftQGMJa5SgliFwCAssQuldhCAIxhnlLGs9j1FxkAAMjkYb/a7AIAUJbYpRo/egO4xhylFLELAEBZYpeKbCUAgG3bxC4A8JdlAeW8il1/kYHMDGwA6ONpt9rsAgDbZklAUWIXAICyxC6V2VIA7GNeUta72HVvFwCAyF72qs0u1dlWALxmTlKa2AUAoCyxSwe2FgCPmY+Utyd23dsFACCit51qs0sXthcAX5mLtCB2AQAoS+zSiS0GwG/mIW2IXQAAytobu35JjSpsM4DuzEGq2NWnNrsAAJQldunIVgPoyvyjHbELAEBZR2LXvV0qsd0AujH3qGR3l9rs0pnBD3Rh3tGW2AUAoCyxS3e2HUB15hytHY1d93YBAFjpUI/a7IKtB1CX+UZ7Yhd+cyAA1ZhrsJ2LXVcZAABY4XCH2uzCX7YgQBXmGfxL7MJXDgggO3MMPhG7AACUdTZ23dulMlsRICvzi8pO9afNLgAAZYldeMx2BMjG3IIHrsSuqwxU5+AAsjCv4AmbXXjNAQJEZ07Rweklq9gFAKCsq7HrKgMd2JoAUZlP8IbNLuzjQAGiMZfo4tJyVewCAFDWiNh1lYEubFGAKMwj2MlmF45xwACrmUN0cnmpKnbhOAcNsIr5AweNil1XGejGgQMACdjsAkAOvsmmmyHLVLEL5zl4gLuYN3DSyNh1lYGOHEDAbOYMXGCzC9c5iIBZzBe6GrZEFbswhgMJAAIaHbuuMgDAGL6JhgFsdmEcBxMwinlCZ0OXp2IXxnJAAVeZIzDQjNh1lYHuHFTAWeYHDGazC3M4sICjzA2YsDQVuzCPgwvYy7yASWbFrqsM8JsDDHjHnICJbHZhPgcZALw3ZVk6M3Ztd+EvwQs8YjbAZDa7cB+HGvCZmQB/TVuSil24l8MN2DazAG4zO3ZdZQCAr4Qu3MhmFwDuI3Thp6nL0Tti13YXAIQuLGGzCwDzCV14bPpSVOwCwFxCFxa6K3ZdZQCgI6ELi/1v9T8AAAoSufDeLcvQO68x2O4C0IHQhUDc2QWAcYQu7HPbElTsAsAYQhcCujt2XWUAoJqPTejCEbf2oM0uAJwnciG4FbFruwtABUIXErDZBYDjhC6cc/vSc1Xs2u4CkJXQhUT8RyUAYB+RC9csWXauvMZguwtAFkIXknJnF+7lmzzIR+jCdcvOP9cYAOAxkQsFrN7s2nIBEJHQhXGW9p7NLgD8JXKhmNWb3W2z3QUgBqEL4y3vPJtdALoTuVBYhM3utgWofgBaErpQnM0uAB2JXJgvxDIzymZ324J8QQAoT+hCIza7AHQhcuE+YZaYkTa72xboCwNAGR+b0IW2osUuAIwkcuF+oZaXEWM31BcIgJRsc4Ft29zZBaAWgQtrhVtaRtzsblvALxQA4Qld4AebXQCyE7kQQ8hlZdTN7rYF/YIBEIZ7uRBH2G6z2QUgG4EL7BY9dn9thhoAzgKILOxWd9vixy4AvYlc4JLId3b/CP3dAgBTuI8LOYTvNJtdACIRuMBQWWLX3V2Ausx3yCn8Vnfb8sQuALUIXOAWmWLXdhfy+v7uptgGMIU5DjWkmeOZYnfbBC9k8+x9/fz/nmZgcpq5DSyTLXaBHI7EjfCtSeBCXalmdcbYtd2FuK6+m8I3N7MZ6ks3mzPGLhDPjMgRvjkIXCC0rLFruwsx3PUeCt9YzF/oKeX8zRq7wForY8dfdrifuAXSyhy7trtwv4jv3KN/kwC+JuLnDKyVdq5mjl3gPtnix/Z3v2yfLcAh2WPXdhfmqvJ+Pfvf0SmCq3yWwP1Sz8rssbttghdm6PJOVYvgLp8bcJ+s8/A/FWIXGEMo/XXka3HHQeCzATipSuza7sJ53p1rfP2AqtJvdbetTuwCx4k0AMr7Z/U/YKAS333ADT42oQvAa2W6qlLsbluhDwYmELkA7FGqp1xjgPoELgBtVdvsblux70bgAptcAI4q11EVY3fbCn5QcIDIBYB/ucYAdQhcAK4ouSysutndtqIfGDxgkwvAVWW7qXLsblvhDw42kQsAb7nGAPkIXABGKr0crL7Z3bbiHyCt2OQCMFr5TrLZhfgELgCc1GGzu20NvmuhJJtcAGZq0UddYnfbmnyglCByAZitTRe5xgAxiFsAmKDTZnfbGn0XQxq2uADcrVUPdYvdbWv2AROWyAVghXYd1DF2t63hB00YIhcAbtQ1dgEAumm57Oscuy0/cACgpbbd0zl2t63xBw8A0EH32AUAqK71ck/sNn8AAIDS2neO2P2t/YMAAJSjbzax+5kHAgCgGLELAFCPJd6/xO5XHgwAIDs984nY/ckDAgBQhNgFAKjD0u4bsfuYBwUAyEa/PCB2n/PAAABZ6JYnxO5rHhwAIDq98oLYfc8DBACQlNgFAMjLUu4NsbuPBwkAiEaf7CB29/NAAQBR6JKdxO4xHiwAYDU9coDYBQCgLLF7nO+mAIBVdMhBYvccDxoAcDf9cYLYPc8DBwDcRXecJHav8eABALPpjQvE7nUeQABgFp1xkdgFAKAssTuG77oAgNH0xQBidxwPJAAwiq4YROyO5cEEAK7SEwOJ3fE8oADAWTpiMLE7hwcVADhKP0wgdufxwAIAe+mGScTuXB5cAOAdvTCR2J3PAwwAPKMTJhO7AACUJXbv4bs2AOA7fXADsXsfDzQA8IcuuInYvZcHGwDQAzcSu/fzgANAXzrgZmJ3DQ86APTj/F9A7K7jgQeAPpz7i4jdtTz4AFCf834hsbueFwAA6nLOLyZ2Y/AiAEA9zvcAxG4cXggAqMO5HoTYjcWLAQD5Oc8DEbvxeEEAIC/neDBiNyYvCgDk4/wOSOzG5YUBgDyc20GJ3di8OAAQn/M6MLEbnxcIAOJyTgcndnPwIgFAPM7nBMRuHl4oAIjDuZyE2M3FiwUA6zmPExG7+XjBAGAd53AyYjcnLxoA3M/5m5DYzcsLBwD3ce4mJXZz8+IBwHzO28TEbn5eQACYxzmbnNitwYsIAOM5XwsQu3V4IQFgHOdqEWK3ll+blxMArnKWFiJ2a/KSAsBxlkYFid26vKwAsJ9zsyixW5sXFwDec14WJnbr8wIDwHPOyeLEbg9eZAD4yfnYgNjtwwsNAH85F5sQu714sQHAediK2O3Hn1UBoDNnYDNity8vOwDdOPsaEru9eekB6MBPNRsTu3j5AajMOdec2GXbfMcLQE3ONsQuXxgKAFRgicN/xC7fGQ4AZOYc4wuxyyMGBQAZOb/4QezyjB8BAZCJM4uHxC7vGB4ARGY5w0tilz0MEQAicj7xlthlL985AxCJM4ldxC5HGS4ArGT5wiFilzMMGQBWcP5w2P9W/wNI68/A+Vj6rwCgA5HLaTa7XGUAATCTc4ZLxC4jGEQAzOB84TLXGBjFtQYARhG5DGOzy2gGFABXOEcYymaXGWx5AThK5DKFzS4zGVwA7OG8YBqxy2wGGACvOCeYyjUG7uBaAwDfiVxuYbPLnQw2ALbNecCNbHa5my0vQF8il9uJXVYRvQB9iFyWcY2B1QxAgNrMeZay2SUCW16AekQuIdjsEonBCFCDeU4YNrtEY8sLkJfIJRybXaIyMAFyMbcJyWaXyGx5AeITuYQmdslA9ALEI3JJwTUGMjFYAWIwj0nDZpdsbHkB1hG5pCN2yUr0AtxH5JKW2CU70Qswj8glPXd2qeLXZigDjGSmUoLYpRrDGeAaywNKcY2BilxtADhO4FKS2KUy0QvwnsilNLFLB6IX4CeRSwtil05EL4DIpRmxS0eiF+hI5NKS2KUz0Qt0IHJpTeyC6AVqErmwiV34TPQCFYhc+ETswk+iF8hI5MIDYheeE71ABiIXXhC78J7oBSISubCD2IX9Ph8swhdYQeDCQWIXzrHtBe4kcuEksQvXiF5gJpELF4ldGEP0AiOJXBhE7MJY7vUCZwlcmEDswjy2vcAeIhcmErswn20v8J3AhZuIXbiXbS/0JnLhZmIX1rDthT4ELiwkdmE9216oSeRCAGIX4rDthfwELgQjdiEm4Qt5CFwITOxCfMIX4hG4kITYhVyEL6wjcCEhsQt5CV+YT+BCcmIXahC+MI7AhULELtQjfOE4gQtFiV2oTfjCcwIXGhC70Mf3g1380o24hYbELvRl60sHAheaE7vAttn6Uoe4Bb4Qu8Aj4pcsxC3wktgF9ngUFAKYFcQtcIjYBc6y/WU2YQtcJnaBUcQvV4lbYDixC8zyLFxEMKIWuI3YBe4mgvsQtcByYheIwi/B5SZsgZDELhDZu4ASw/cRs0BKYhfITAyPI2aBksQuUNnRgKsUx+IVYNu2/wP5mOLjgJcXRwAAAABJRU5ErkJggg==);
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 8px;
}
</style>
